import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Takshila-VLSI-Company-Brochure.pdf";
    window.open(pdfUrl);
};

const FINFET = () => {
  return (
    <div>
          <Helmet>
          <title>FinFET Layout Design Training Course & Fee Info | Takshila VLSI</title>
            <meta name="description" content="Master advanced FinFET Layout Design with sub-14nm layout techniques, DRC/LVS checks, EDA tools, and industry-relevant workflows at Takshila VLSI." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/product/finfet-layout-design/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="FinFET Layout Design Training Course & Fee Info | Takshila VLSI" />
            <meta property="og:description" content="Master advanced FinFET Layout Design with sub-14nm layout techniques, DRC/LVS checks, EDA tools, and industry-relevant workflows at Takshila VLSI." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/product/finfet-layout-design/" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="article:modified_time" content="2024-08-14T12:57:57+00:00" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/12/FinFet-Trainign.png" />
            <meta property="og:image:width" content="1920" />
            <meta property="og:image:height" content="1080" />
            <meta property="og:image:type" content="image/png" />
            <meta name="twitter:card" content="summary_large_image" />
           </Helmet>
          <Header/>
      <main>
          <section class="section-banner pg-banner ws-section pt-5 bg-14">
          <div class="container text-center">
                      <div class="row justify-content-around p-lg-5 pb-0">
                          <div class="col-md-9">
                              <div class="pg-title-sec">
                                  <h1 className='pg-title pb-3'>FINFET Layout <span className='bg-txt mx-3'>Design</span> Training
                                  </h1>
                                  <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                              </div>
                          </div>
                          <div class="col-md-12 align-self-center mb-3">
                                  <a href="/register-now">
                                      <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                  </a>
                          </div>
                      </div>
                      <div class="row justify-content-center img-radius g-3">
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img1} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-8 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                              </div>
                          </div>
                          <div class="col-md-3 align-self-end">
                          <img src={img2} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-7 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners became better at their job</p>
                              </div>
                          
                          </div>
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img3} alt=''/>
                          </div>
                      </div>
          </div>
      </section>
      <section className='course-desc p-lg-5 bg-14'>
              <div class="container text-center">
                      <div class="row justify-content-around text-center">
                          <div class="col-md p-5">
                                  <h2 className='ws-section_heading pd-03'><span className='font-thin'>FinFet Layout Design Courses & Analog Layout Design Training
                                  </span> Courses in Bangalore/ Hyderabad</h2>
                          </div>
                      </div>
                      <div class="row justify-content-around">
                          <div class="col-md">
                                  <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                  <div className='text-left text-xl'>
                                  <p>This Course is mainly focuses on FinFet layout design techniques used in the physical design of standard cells, Memory layout design and full custom digital and analog blocks. Starting with the FinFet layouting of basic MOS transistors to industry standard project execution in FinFet technologies, the course develops to cover the more advanced techniques used in creating area efficient full custom digital &amp; analog layouts.</p>
                                  </div>
                          </div>
                      </div>
              </div>
      </section>
      <section className='highlight-section p-lg-5 p-2 bg-14'>
          <div class="container bg-9 p-lg-5 p-3 radius-1">
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Eligibility</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>B.E/B.Tech in ECE/EEE.</div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>M.E/M.Tech/M.S in VLSI System Design/Embedded Systems/Digital Electronics.
                      </div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>1-3 Years Experienced Analog Layout Design Working Professionals.
                      </div>
                  </div>
                  </div>
              </div>
              </div>
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Course Duration</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>11 Weeks</div>
                  </div>
                  </div>
              
              </div>
              </div>
              <div>
              <div className='txt-2 mb-2'>Course Highlights</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Familiarity with the concepts of FinFet Technologies and processes.</div>
                  </div>
              
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Area efficient Layout design of digital & analog cells.</div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Silicon area reduction techniques & reliability techniques.</div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Understanding deep submicron issues.
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Full custom & digital FinFet floor planning methodologies.</div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Critical Industry standard project execution under the guidance of 12+ year’s industry expert.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>24×7 Lab Support with classroom practice handouts and course material.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Soft skills development, complete suite of job oriented ASIC Verification training with 100% placement assistance.
                      </div>
                  </div>
                  
                  </div>
              </div>
              </div>
                  
          </div>
      </section>

      <section className='author-section p-lg-5 p-2 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 mr--10 mt-5 p-3 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/ram/'><h4>Mr.Ram</h4></a>
              <h6 className='pb-3'>(Analog Layout Design Expert)</h6>
              <p>A VLSI Professional with 15+ years of rich experience in Analog Mixed-signal Layout design. Worked with Tier 1 Semiconductor Product and Service companies and also Product based startup companies which helped me to understand the learning curves and business models. Having facilitative leadership skills and having a proven track record with leading teams on-site &amp; offshore design centers.</p>
              <p>I believe “Experience comes from doing the same things repeatedly. But expertise will come only when you do the same thing in the different approaches” I strongly believe more in Expertise than experience.</p>

              <div class="wpb_wrapper">
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Expertise Areas:</strong></p>
                      <ul>
                        <li>AMS IP layout design.</li>
                        <li>Memory layout design.</li>
                        <li>Module based floorplanning techniques.</li>
                        <li>Full chip / Block integration.</li>
                        <li>Physical verification (LVS, DRC, ERC, Antenna fix, soft checks, stress &amp; CLDRC).</li>
                        <li>Signal integrity / Cross talk and Static IR drop analysis.</li>
                        <li>All Other deep submicron issues like STI, WPE, and LOD.</li>
                        </ul>

                        <p><strong>Technology Process Worked On:</strong></p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Finfet Technologies:</strong> 7nm, 10nm, 14nm, 16nm, and 22nm.<strong><br/><br/>
                      Nominal Technologies: </strong>28nm, 32nm, 40nm, 65nm, 90nm,130nm, 180nm &amp; 440nm.<br/>
                      <strong><br/>
                      IC Foundries Worked with:&nbsp;</strong>TSMC,&nbsp;UMC,&nbsp;GF, SAMSUNG, ST, INTEL</p>
                  
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>EDA tools known for layout design :</strong> Cadence VLE, L, XL, and GXL and Mentor Graphics IC-Station<strong>.<br/>
                      <br/>
                      Physical verification tools known: </strong>Calibre, Assura, PVS and Hercules.</p>
                      </div>
                  </div>
                      </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

      <section className='curriculum-section pt-5'>
          <div className='container'>
              <div class="row justify-content-center mb-5">
              <div class="col-lg-8 text-center">
              <h3 class="ws-section_heading pb-03 txt-3">FINFET IC Design Training / FINFET Chip Layout training / FINFET Layout Training
              </h3>
              </div>
              </div>
              <div class="row mb-5">
                  <div class="col-lg-8">
                  <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
                  </div>
                  <div class="col-lg-4 align-self-center">
                 <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                  
                  </div>
              </div>
              <div className='row'>
                  <div className='col-lg'>
                  <div className='curriculum-accord accordion'>
                          <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>Module 1: Advanced Unix/Linux CMD's</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction and working knowledge of Unix/Linux commands</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>File handling skills in UNIX/LINUX |SED & AWK</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to programming languages used in IC-Design </div>
                              </div>
                          </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>Module 2: Design for Manufacturability Checks (DFM)</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Latch-up, Antenna Effect   </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Electrical rule check (ERC) and Design rule check (DRC)  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Electro-migration (EM), IR Drop & Self-Heat (SH)  </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>Module 3: Deep sub-micron process challenges</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Well proximity Effect (WPE), Length of Diffusion (LOD) </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Shallow trench Isolation (STI)
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>OSE/PSE
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Metal Density effects
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>Module 4: Analog Circuit Layout Design Techniques</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Common centroid & Interdigitation matching techniques
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Critical signals shielding techniques
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Constraint & Module based floor planning techniques
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Guard / Seal ring techniques
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>Module 5: Custom Layout Techniques</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>STD Cell Layout design techniques
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>I/O Layout design techniques
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Memory Layout Design techniques
                                  </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>Module 6: Layout Design of Critical Analog Circuits</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Advanced/Critical Analog Circuits
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Complete Physical Verification Checks required for a Successful tape-out 
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>Module 7: Industry standard Project Execution</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Working on Critical Analog Circuits that are important in Industry
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>Module 8: Mock Interviews & Personality improvement</Accordion.Header>
                          </Accordion.Item>
                          

                          </Accordion>
                          </div>
                  </div>
              </div>

          </div>
                  </section>


                  <Companysec/>
      <Whysec/>           
      <Offersec/>


      <section className='ws-section pb-5 bg-white'>
          <div class="container text-center">
          <div className='row pb-3'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Connect With Us</h2>
              </div>
              </div>
          <div class="row justify-content-around">
                          <div class="col-lg-5">
                              <div className='trainer-box'>
                                  <div className='content-box wd-80 d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                  your goals.</h5>
                                  </div>
                                  </div>
                                  <div className='trainer-img img-radius mb-3'>
                                  <img src={img4} alt=''/>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-6">
                              
                              <iframe
                                  aria-label='Register Now'
                                  width="100%"
                                  height="850"
                                  src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                  frameborder="0" 
                              
                              />
                          
                          </div>
                      </div>
          </div>
      </section>

      
      <section className='course-faq-section ws-section p-lg-5 bg-14'>
          <div className='container'>
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Frequently Asked Questions</h2>
              </div>
              </div>
              <div className='row justify-content-center pb-5'>
                  <div className='col-lg-10'>
                  <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>1. What is the main goal of the FinFET layout design course?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our main goal in our <strong>FinFET layout design course </strong>is to provide the best skills needed to design FinFET layouts for cells, memory layouts, and custom digital and analog blocks. We begin with fundamental concepts and progress to more advanced strategies to ensure that you are fully equipped for practical projects.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>2. Who can benefit from FinFET design training?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our training, on FinFET design is for professionals who have a background in electronics or Electrical design and also for individuals with 1-3 years of experience in analog layout design. If you want to improve your skills and delve further into FinFET technologies, this course is perfect for you!</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>3. Who can enrol in the VLSI FinFET layout design course?</Accordion.Header>
                              <Accordion.Body>
                              <p>A degree in ECE, EEE, or a related field is a requirement for enrolling in the <strong>VLSI FinFET layout design </strong>course. Having 1-3 years of experience in analog layout design can help you grasp concepts easily and quickly during training.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>4. How do the FinFET layout design tutorials differ from other layout design courses?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our<strong> FinFET layout design tutorials</strong> are designed to teach so that everyone will learn and understand the deep concepts of FinFET technology. We believe in deep training on both basic and advanced FinFET design techniques, focusing on the latest industry standards and practical applications.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>5. How long is the VLSI FinFET layout design course?</Accordion.Header>
                              <Accordion.Body>
                              <p>The <strong>VLSI FinFET layout design course</strong> runs for 11 weeks. During this time, you will engage in complete training, and real practice, and learn real-world project execution to build your expertise in FinFET layout design.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>6. Will the advanced FinFET design training include mock interviews?</Accordion.Header>
                              <Accordion.Body>
                              <p>Absolutely! Our <strong>advanced FinFET design training</strong> includes mock interviews and personality improvement sessions. We aim to prepare you thoroughly for job interviews and enhance your professional skills for a successful career.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          </Accordion>
                  </div>
              </div>
              <div class="row justify-content-center mt-5">
                      <div class="col-lg-9">
                          <div class="callaction-2">
                              <div class="row g-3">
                              <div class="col-lg-7">
                                  <h2>Don't see your questions ? answered here?</h2>
                              </div>
                              <div class="col-lg-4 align-self-center text-center">
                              <a href="/contact-us/">
                              <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                              </a>
                              </div>
                              </div> 
                          </div>
                      </div>
                  </div>
          </div>
      </section>

      
      <Videoreview/>
      <Enrollaction/>
      <Partnersec/> 
      </main>
      <Footer/>
      </div>
  )
}

export default FINFET